const css = require('./text.css');
const _ = require('lodash');
const $ = require('jquery');

const SELECTOR_TEXTFIELD = `.${css.textfield}`;
const WARN_MISSED_PATH = 'Text must accept path as attribute';

const ALLOWED_KEYS = [
    'ArrowLeft', 'Left', // IE надо было выделиться
    'ArrowUp', 'Up',
    'ArrowRight', 'Right',
    'ArrowDown', 'Down',
    'Backspace',
    'Tab',
    'Delete'
];

const ALLOWED_CHARS_WITH_MODIFIER = ['a', 'c', 'x', 'r'];

class Text {
    constructor(locator) {
        this._logger = locator.resolve('logger');
        this.template = require('./text.hbs');
    }

    /**
     * Render method
     * @returns {Promise}
     */
    render() {
        return this.$context.getWatcherData()
            .then((data) => Object.assign({}, { css }, this.$context.attributes, this.$context.props, data));
    }

    /**
     * Bind events
     * @returns {Object}
     */
    bind() {
        let mask = this.$context.props.mask;

        if (mask) {
            this.setMask(mask);
        }

        return {
            input: {
                [SELECTOR_TEXTFIELD]: _.partial(
                    this.inputEvent,
                    this.$context.props.signals.inputText
                )
            },
            keypress: {
                [SELECTOR_TEXTFIELD]: this.validate
            },
            blur: {
                [SELECTOR_TEXTFIELD]: _.partial(
                    this.inputEvent,
                    this.$context.props.signals.blurText
                )
            },
            paste: {
                [SELECTOR_TEXTFIELD]: this.validate
            }
        };
    }

    /**
     * Шлёт сигнал события инпута
     * @param {String} signal
     * @param {Object} e
     */
    inputEvent(signal, e) {
        const path = this.$context.attributes['path'];
        const value = e.currentTarget.value;
        const errorPath = this.$context.attributes['error-path'];
        const scheme = this.$context.props.scheme;
        const errorMessage = this.$context.attributes['error-message'];

        if (!path) {
            this._logger.warn(WARN_MISSED_PATH);
            return;
        }

        this.$context.signal(signal, {path, value, errorPath, scheme, errorMessage});
    }

    /**
     * Проверяет что введенный символ соответствует допустимым значениям в схеме,
     * наличие схемы автоматически предполагает запрет вставки
     * @param {Event} e
     */
    validate(e) {
        const scheme = this.$context.props.scheme;
        const regexp = _.get(scheme, 'properties.value.regexp');

        if (!regexp) {
            return;
        }

        if (ALLOWED_KEYS.includes(e.key)) {
            return;
        }

        if (e.type == 'paste') {
            const clipboardData = e.clipboardData || window.clipboardData;
            const pastedValue = clipboardData.getData('Text');
            const isValidPastedValue = regexp.test(pastedValue);

            if (!isValidPastedValue) {
                e.preventDefault();
            }

            return;
        }

        const modifierPressed = e.getModifierState('Control') || e.getModifierState('Meta');
        const pressedChar = String.fromCharCode(e.which);

        if (modifierPressed && ALLOWED_CHARS_WITH_MODIFIER.includes(pressedChar)) {
            return;
        }

        const clearChar = pressedChar.replace(regexp, '');

        if (!clearChar) {
            e.preventDefault();
        }
    }

    /**
     * Устанавливаем маску
     * @param {String} mask
     */
    setMask(mask) {
        let element = this.$context.element;
        $(element).find(SELECTOR_TEXTFIELD).mask(mask);
    }
}

module.exports = {
    constructor: Text
};



// WEBPACK FOOTER //
// ./packages/account-ui/text/index.js